module.exports = "<div class=\"ui-card ui-card-hover padding-md\"\r\n    ng-if=\"!$ctrl.desplegar\"\r\n    ng-click=\"$ctrl.onSelect()\"\r\n    title=\"Clic para editar anticipo\">\r\n  <div class=\"kd-item\">\r\n    <div class=\"text-bold flex\">\r\n      {{$ctrl.leyenda}}\r\n    </div>\r\n    <div>\r\n      {{$ctrl.data.importe | currency}}\r\n    </div>\r\n  </div>\r\n</div>\r\n";


//////////////////
// WEBPACK FOOTER
// ./src/viaticos/components/shared/anticipos/anticipo/informacion/template.html
// module id = 3284
// module chunks = 0